var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2777 12.8891C16.9524 12.8891 17.5188 13.446 17.4156 14.1123C16.8103 18.0323 13.4545 20.9428 9.40717 20.9428C4.92928 20.9428 1.2998 17.3134 1.2998 12.8365C1.2998 9.14809 4.10191 5.7123 7.25665 4.93546C7.93454 4.76809 8.62928 5.24493 8.62928 5.94283C8.62928 10.6712 8.78823 11.8944 9.68612 12.5597C10.584 13.2249 11.6398 12.8891 16.2777 12.8891Z",
    stroke: "#C1B9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6921 8.95157C20.7458 5.91368 17.0142 1.01684 12.4669 1.10105C12.1132 1.10736 11.83 1.4021 11.8142 1.75473C11.6995 4.25263 11.8542 7.48947 11.9406 8.95684C11.9669 9.41368 12.3258 9.77263 12.7816 9.79894C14.29 9.88526 17.6448 10.0032 20.1069 9.63052C20.4416 9.57999 20.6869 9.28947 20.6921 8.95157Z",
    stroke: "#C1B9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.019ac72ac2de5070ba870ece4ed67d32.svg";
export { ForwardRef as ReactComponent };